export enum WATCH_TYPE {
  LIVE = 'LIVE',
  VIDEO = 'VIDEO'
}

export enum USER_SCORE {
  DISLIKE = 'DISLIKE',
  LIKE = 'LIKE',
  NEUTRAL = 'NEUTRAL'
}

export enum VIDEO_ITEM_TYPE {
  COLUMN = 'column',
  COLUMN_LARGE = 'column-large',
  COLUMN_ONLY = 'column-only',
  ROW = 'row',
  ROW_SMALL = 'row-small'
}

export enum RESTRICTION_TYPE {
  NATIVE_ONLY = 'NATIVE_ONLY',
  REQUIRE_LOGGED_IN = 'REQUIRE_LOGGED_IN',
  USE_TICKET = 'USE_TICKET'
}
